module.exports = __webpack_public_path__ + "static/media/msp_06.d373d051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msp_06.png
// module id = 74
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34